module.exports = __webpack_public_path__ + "static/img/jpeg.e2386478.png";